/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { apiUrl } from '../utilities/apiUrl';

export const RenderBG = () => {
  const [checkIfLoggedIn, setCheckedIfLoggedIn] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  /**
   * automatically run when page starts loading.
   *
   * Calls the check if logged in endpoint using browser cookies.
   * Redirection might be necessary depending on the authenticity of the cookies.
   */
  useEffect(() => {
    fetch(apiUrl('/auth/'), {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        setCheckedIfLoggedIn(true);
        setIsLoggedIn(data.success);
      })
      .catch((err) => {
        console.log(err);
      });
  });

  return checkIfLoggedIn ? (
    isLoggedIn ? (
      <Navigate to="/dashboard" />
    ) : (
      <div>
        <Outlet />
      </div>
    )
  ) : (
    <div />
  );
};
